import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { TermsModalComponent } from '../../modal/terms/terms-modal/terms-modal.component';
import { TakeOverModalComponent } from '../../modal/terms/take-over-modal/take-over-modal.component';
import { BrandService } from '../../brand/brand.service';
import { TermsService } from '../terms.service';

@Component({
  moduleId: module.id,
  selector: 'terms-widget',
  templateUrl: 'terms-widget.component.html',
})
export class TermsWidgetComponent {
  @ViewChild(TakeOverModalComponent, {static: false}) takeOverModal: TakeOverModalComponent | void;
  @ViewChild(TermsModalComponent, {static: false}) termsModal: TermsModalComponent | void;

  terms: any = null;

  constructor(
    private brandService: BrandService,
    private termsService: TermsService,
    private router: Router,
  ) {
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public show() {
    this.termsService.fetchTerms()
    .subscribe((terms: any) => {
      this.terms = terms;
    });
    if (this.takeOverModal instanceof TakeOverModalComponent) {
      this.takeOverModal.show();
    }
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onTermsClicked() {
    if (this.takeOverModal instanceof TakeOverModalComponent) {
      this.takeOverModal.hide();
    }
    if (this.termsModal instanceof TermsModalComponent) {
      this.termsModal.show();
    }
  }

  onTermsCloseClicked() {
    if (this.termsModal instanceof TermsModalComponent) {
      this.termsModal.hide();
    }
    if (this.takeOverModal instanceof TakeOverModalComponent) {
      this.takeOverModal.show();
    }
  }

  onAgreeClicked() {
    this.agree()
      .subscribe((res: any) => {
        if (this.takeOverModal instanceof TakeOverModalComponent) {
          this.takeOverModal.hide();
        }
        if (res.success) {
          this.router.navigate(['/dashboard']);
        }
      });
  }

  onAcceptClicked() {
    this.agree()
      .subscribe((res: any) => {
        if (this.termsModal instanceof TermsModalComponent) {
          this.termsModal.hide();
        }
        if (res.success) {
          this.router.navigate(['dashboard']);
        }
      });
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

   private agree(): Observable<any> {
     return this.termsService.accept(this.terms.id);
   }
}
